import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialoglogin";
import TermsOfServices from "../Policies/toc";

interface TermsOfServiceDialogProps {
  trigger: React.ReactNode;
}

const TermsOfServiceDialog = ({ trigger }: TermsOfServiceDialogProps) => {
  // Define the terms content as an array of objects

  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-h-screen overflow-y-auto bg-[url('/login/login-back.png')] bg-cover px-6 py-10 font-kanit text-white sm:py-14 lg:min-w-[910px]">
        <div>
          <TermsOfServices />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsOfServiceDialog;
